export default __webpack_public_path__ + "static/media/DSC_7484.f2ccec7c.jpg";